<script>
  import { ComponentType } from '../../../../js/constants';
  import { getAccessibilityRedesignRenderState } from '../../../../js/stores';

  import Cart from './Cart/Cart.svelte';
  import HomeLink from '../HomeLink/HomeLink.svelte';
  import MainContentJumpLink from './MainContentJumpLink/MainContentJumpLink.svelte';
  import NavList from './NavList/NavList.svelte';
  import Scrim from './Scrim/Scrim.svelte';

  export let data = {};
  export let desktopMode;

  const accessibilityRedesignRender = getAccessibilityRedesignRenderState();

  $: alignment = data.alignment || 'center';
</script>

{#if $accessibilityRedesignRender}
  <MainContentJumpLink />
{/if}

<nav
  class="DesktopNav align-{alignment}"
  class:desktop-nav-accessibility-redesign={$accessibilityRedesignRender}
  data-component-type={ComponentType.MAIN_NAVIGATION}
>
  {#if data.primaryNavItems || data.secondaryNavItems || data.cart}
    <div class="left-slot">
      <HomeLink {...data.home} />
    </div>
    <div class="slot-spacer"></div>
    <div class="middle-slot">
      {#if data.primaryNavItems}
        <NavList navItems={data.primaryNavItems} {alignment} {desktopMode} />
      {/if}
    </div>
    <div class="slot-spacer"></div>
    <div class="right-slot">
      {#if data.secondaryNavItems}
        <NavList navItems={data.secondaryNavItems} alignment="right" {desktopMode} />
      {/if}
      {#if data.cart}
        <Cart data={data.cart} />
      {/if}
    </div>
  {:else}
    <HomeLink {...data.home} />
  {/if}
</nav>

{#if $accessibilityRedesignRender}
  <Scrim />
{/if}

<style>.DesktopNav {
  border-width: 0;
  border-style: solid;
  color: var(--color-text, #1a1a1a);
  background-color: var(--color-background, #fff);
  border-color: var(--color-border, #d9d9d9);
  box-sizing: border-box;
  position: relative;
  min-width: 320px;
  border-bottom-width: 1px;
  z-index: 3;
  display: none;
  padding: 15px;
}
@media (min-width: 1280px) {
  .DesktopNav {
    display: flex;
  }
}

.desktop-nav-accessibility-redesign {
  padding: 4px 15px 0;
}

.align-left {
  justify-content: flex-start;
}

.align-center {
  justify-content: center;
}

.align-right {
  justify-content: flex-end;
}

.left-slot,
.middle-slot,
.right-slot {
  display: flex;
  align-items: center;
}

.left-slot {
  width: 100%;
  flex: 0 1 auto;
  justify-content: flex-start;
}

.right-slot {
  width: 100%;
  flex: 0 1 auto;
  justify-content: flex-end;
}

.slot-spacer {
  width: 100%;
  max-width: 35px;
}

.align-left .left-slot,
.align-right .right-slot {
  width: auto;
  flex: 1 0 auto;
}</style>
